module.exports = __webpack_public_path__ + "static/media/phone.5ff629a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/GulpOfWater/phone.mp4
// module id = 1YWo
// module chunks = 1